import { Grid, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";

import { Eye, EyeClosed, Pin, PinCircle } from "@solar-icons/react/ssr";
import { getColumnProfiles } from "./bidColumns";
import { getShowRunning } from "./bidStore";

export const ColumnsMenu = ({
    isOpen,
    close,
    anchorEl,
    onToggleVisibility,
    onToggleSticky,
}) => {
    const isRunning = getShowRunning();
    const columnProfiles = getColumnProfiles();
    const controllableColumns = columnProfiles.filter(
        (col) => !col.alwaysVisible && !col.restricted,
    );
    const maxPinningReached =
        controllableColumns.filter((col) => col.sticky).length >= 4;
    const maxHiddenReached =
        controllableColumns.filter((col) => col.visible).length <= 2;

    return (
        <Menu open={isOpen} anchorEl={anchorEl} onClose={close}>
            {controllableColumns.map((col) => {
                const disablePinning = maxPinningReached && !col.sticky;
                const disableHide = maxHiddenReached && col.visible;
                return (
                    <MenuItem key={col.id}>
                        <ColumnMenuItem
                            id={col.id}
                            defaultSticky={col.sticky}
                            defaultVisible={col.visible}
                            label={col.headerText}
                            onToggleVisibility={onToggleVisibility}
                            onToggleSticky={onToggleSticky}
                            disablePinning={disablePinning}
                            disableHide={disableHide}
                            isRunning={isRunning}
                            columnProfiles={columnProfiles}
                        />
                    </MenuItem>
                );
            })}
        </Menu>
    );
};

const ColumnMenuItem = ({
    id,
    label,
    defaultVisible,
    defaultSticky,
    onToggleVisibility,
    onToggleSticky,
    disablePinning,
    disableHide,
    isRunning,
    columnProfiles,
}) => {
    const [hidden, setHidden] = useState(defaultVisible);
    const [sticky, setSticky] = useState(defaultSticky);
    useEffect(() => {
        if (!defaultVisible) {
            columnProfiles.find((col) => col.id == id).visible = defaultVisible;
        }
        if (!defaultSticky) {
            columnProfiles.find((col) => col.id == id).sticky = defaultSticky;
        }
    }, []);
    const handleToggleVisibility = () => {
        const nowHidden = !hidden;
        setHidden(nowHidden);
        onToggleVisibility(id, nowHidden);
    };
    const handleToggleSticky = () => {
        const nowSticky = !sticky;
        setSticky(nowSticky);
        onToggleSticky(id, nowSticky);
    };
    return (
        <Grid
            container
            alignItems={"center"}
            fontSize={14}
            justifyContent={"space-between"}
        >
            <Grid item>
                <span>{label}</span>
            </Grid>
            <Grid item>
                <Grid container>
                    <Grid item>
                        <Tooltip
                            placement="right"
                            title={
                                disableHide &&
                                "You reached hide column limit, please show another column first"
                            }
                        >
                            <span>
                                <IconButton
                                    size="small"
                                    disabled={disableHide}
                                    onClick={handleToggleVisibility}
                                >
                                    {hidden ? (
                                        <Eye size={14} />
                                    ) : (
                                        <EyeClosed size={14} />
                                    )}
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <Tooltip
                            placement="right"
                            title={
                                isRunning
                                    ? "You cannot unpin columns in running mode"
                                    : disablePinning
                                      ? "You can only pin 4 columns, please unpin another one first"
                                      : undefined
                            }
                        >
                            <span>
                                <IconButton
                                    disabled={disablePinning || isRunning}
                                    size="small"
                                    onClick={handleToggleSticky}
                                >
                                    {sticky ? (
                                        <PinCircle size={14} />
                                    ) : (
                                        <Pin size={14} />
                                    )}
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
